/**
 * 固定小数长度
 * @param {Number} num 数字
 * @param {Number} [digits=2] 小数长度
 * @param {Boolean} [reserved=false] 是否保留多余的 0
 * @returns {String} 处理后的数字
 */
export function fixed(number, digits = 2, reserved = false) {
  let num = parseFloat(number);
  if (isNaN(num)) {
    num = 0.0;
  }
  const fixedNum = num.toFixed(digits);
  if (reserved) {
    return fixedNum;
  }
  // 移除多余的 0，并保证返回字符串
  return String(parseFloat(fixedNum));
}

export function uppercase(value) {
  if (typeof value !== "string") {
    return value;
  }

  return value.toUpperCase();
}
